import BusinessIcon from "@mui/icons-material/Business";
import ContactPhoneIcon from "@mui/icons-material/ContactPhone";
import MessageIcon from "@mui/icons-material/Message";
import PhoneIcon from "@mui/icons-material/Phone";
import {
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  ListSubheader,
  Tooltip
} from "@mui/material";
import React from "react";
import { ReactNode } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { GemRoutes } from "../../Routes";

interface DrawerListItem {
  label: string;
  icon?: ReactNode;
  path: string;
}
interface DrawerListGroup {
  label: string;
  items: DrawerListItem[];
}

const drawerListGroups: DrawerListGroup[] = [
  {
    label: "GEM",
    items: [
      {
        label: "Center Messages",
        icon: <MessageIcon />,
        path: GemRoutes.AdminCenterMessages
      },
      {
        label: "Center Settings",
        icon: <BusinessIcon />,
        path: GemRoutes.AdminCenters
      },
      {
        label: "Phone Number Settings",
        icon: <PhoneIcon />,
        path: GemRoutes.AdminPhoneNumbers
      }
    ]
  },
  {
    label: "Ivr",
    items: [
      {
        label: "User Skills Config",
        icon: <ContactPhoneIcon />,
        path: GemRoutes.AdminIvrUserSkills
      }
    ]
  }
];

interface HomeDrawerItemsProps {
  isOpen: boolean;
}
const HomeDrawerItems: React.FC<HomeDrawerItemsProps> = ({ isOpen }) => {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <List>
      {drawerListGroups.map(({ label, items }, index1) => (
        <span key={index1}>
          {isOpen && <ListSubheader>{label}</ListSubheader>}
          {items.map(({ label, icon, path }, index2) => (
            <Tooltip title={isOpen ? "" : label} placement="right" arrow key={index2}>
              <ListItem key={label} disablePadding sx={{ display: "block" }} onClick={() => navigate(path)}>
                <ListItemButton
                  sx={sx => ({
                    backgroundColor: location.pathname.includes(path) ? sx.palette.action.selected : undefined,
                    minHeight: 48,
                    justifyContent: isOpen ? "initial" : "center",
                    px: 2.5
                  })}
                >
                  <ListItemIcon sx={{ minWidth: 0, mr: isOpen ? 3 : "auto", justifyContent: "center" }}>
                    {icon}
                  </ListItemIcon>
                  <ListItemText primary={label} sx={{ opacity: isOpen ? 1 : 0 }} />
                </ListItemButton>
              </ListItem>
            </Tooltip>
          ))}
          {index1 !== drawerListGroups.length - 1 && <Divider />}
        </span>
      ))}
    </List>
  );
};

export default HomeDrawerItems;
